import React from 'react'
import { Space } from 'antd'
import Title from 'antd/es/typography/Title'
import { useSelector } from 'react-redux'
import { useFetchTextAssignmentSubmissionsQuery } from '../../../../../store/apis/submission.api'
import { useParams } from 'react-router'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { fetchTextAssignmentSubmissionsSelectors } from '../../../../../store/apis/utils/selectors/submission.api.selectors'
import InstructionsButton from './InstructionsButton'
import { useVersionId } from '../../../../../utils/parseURL.helper'

const TextSubmissionDrawerHeader = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const { token } = useParams()
    const versionId = useVersionId()

    const { data: submission } = useFetchTextAssignmentSubmissionsQuery(
        { token, versionId },
        {
            selectFromResult: result => {
                return fetchTextAssignmentSubmissionsSelectors.byId({ id: openedSubmissionId }, result)
            },
        },
    )

    return (
        <Space size='middle'>
            <Title level={3} style={{ margin: 0, fontSize: '1rem' }}>
                {submission?.studentId || '...'}
            </Title>
            <InstructionsButton />
        </Space>
    )
}

export default TextSubmissionDrawerHeader
